package org.matthewo.js

@Suppress("NOTHING_TO_INLINE")
inline fun Number.toFixed(index: Int): String = asDynamic().toFixed(index) as String
